<template>
  <div v-if="documento.id" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">
        Detalhes do Modelo de Contrato nº {{ documento.id }}
      </h4>
      <button class="btn btn-secondary" @click="voltar">Voltar</button>
    </div>
    <p></p>

    <!-- Informações Básicas -->
    <FormSection title="Informações do Modelo">
      <div class="info-group">
        <strong>Título:</strong> {{ documento.titulo || '-' }}
      </div>
      <div class="info-group">
        <strong>Status:</strong>
        <span v-if="documento.em_uso">Em uso pelo sistema</span>
        <span v-else>Ainda não utilizado pelo sistema</span>
      </div>
    </FormSection>

    <!-- Conteúdo do Contrato -->
    <FormSection title="Conteúdo">
      <div class="info-group">
        <div v-safe-html="documento.conteudo || '<em>Sem conteúdo</em>'"></div>
      </div>
    </FormSection>
  </div>
  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import axios from '@/services/axios';
import FormSection from '@/components/Layout/FormSection.vue';
// import LoadingSpinner from '@/components/Layout/LoadingSpinner.vue';

export default {
  components: { FormSection },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const documento = reactive({});

    const voltar = () => {
      router.push('/configuracoes/documentos');
    };

    const carregarDocumento = async (id) => {
      try {
        const response = await axios.get(`/configuracoes/documentos/${id}`);
        Object.assign(documento, response.data);
      } catch (error) {
        console.error('Erro ao carregar documento:', error);
      }
    };

    onMounted(() => {
      const id = route.params.id;
      if (id) carregarDocumento(id);
    });

    return { documento, voltar };
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.info-group {
  margin-bottom: 10px;
}
</style>
